import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Button, Typography } from "@material-ui/core";

import useStyles from "./styles";
import { Authenticated, hasRole } from "../../models/User";
import { TableColumnConfiguration } from "../../components/layout/table/types";
import { Currency } from "../../components/misc/Currency";
import { get } from "../../api/api";
import Table from "../../components/layout/table";
import { useI18n } from "../../hooks/useI18n";
import { TFunction } from "i18next";
const fetchReceiptItems = async (receiptId: string): Promise<ReceiptItem[]> => {
  const response = await get(`/v1/mpos/receipt-items?receiptId=${receiptId}`);
  return response.json();
};

interface ReceiptItem {
  id: string;
  productName: string;
}

const innerTableColumnConfiguration = (
  user: Authenticated,
  t: TFunction
): TableColumnConfiguration<any>[] => [
  {
    name: t("common.tableHeaders.product"),
    renderItem: receiptItem => receiptItem.productName
  },
  {
    name: t("common.messages.price"),
    renderItem: receiptItem => {
      if (receiptItem.depositFee) {
        return (
          <>
            <Currency value={receiptItem.price} />
            <Typography color="textSecondary" variant="body2" component={"p"}>
              incl. deposit fee (
              <Currency
                value={receiptItem.depositFee}
                currency={receiptItem.currency}
              />
              )
            </Typography>
          </>
        );
      }
      return (
        <Currency value={receiptItem.price} currency={receiptItem.currency} />
      );
    }
  },
  {
    name: t("common.formFields.campaignPrice"),
    renderItem: receiptItem => receiptItem?.campaignPrice
  },
  {
    name: t("common.tableHeaders.quantity"),
    renderItem: receiptItem => receiptItem.quantity
  }
  // {
  //   name: "",
  //   renderItem: receiptItem => {
  //     return hasRole(user, ["Root"]) ? (
  //       <Button
  //         variant="contained"
  //         color="primary"
  //         style={{ fontSize: "0.75rem", padding: "4px 8px", minWidth: "auto" }}
  //       >
  //         Refund
  //       </Button>
  //     ) : (
  //       <></>
  //     );
  //   }
  // }
];

const MobilePOSReceiptItems: React.FC<{
  user: Authenticated;
  receiptId: string;
}> = ({ user, receiptId }) => {
  const classes = useStyles();
  const { t } = useI18n();

  const { data, isLoading, isError } = useQuery(
    ["receiptItems", receiptId],
    () => fetchReceiptItems(receiptId),
    {
      staleTime: Infinity
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError)
    return <div>{t("common.messages.errorLoadingReceiptItems")}</div>;
  if (!data || data.length === 0)
    return <div>{t("common.messages.noDataAvailable")}</div>;

  return (
    <div className={classes.detailTable}>
      <Table
        columns={innerTableColumnConfiguration(user, t)}
        data={data}
        keyExtractor={receiptItem => receiptItem.id}
      />
    </div>
  );
};

export default MobilePOSReceiptItems;
